import { useMemo } from 'react';
import BookingBestHourSuggest from './booking-best-hour-suggest';
import BookingDateTimePicker from './booking-date-time-picker';
import BookingSamedayHour from './booking-sameday-hour';
import { useBookingStore } from '@/stores/booking/booking-store-provider';

type DateTimePickerByServiceProps = {
  onSchedule: (time: number) => void;
};

const DateTimePickerByService = ({
  onSchedule,
}: DateTimePickerByServiceProps) => {
  const {
    selectedService,
    orderTime,
    estimatedRequestData,
    estimatedData,
    bestHourSuggest,
  } = useBookingStore((state) => state);

  const showSamedayHour = useMemo(() => {
    return Boolean(
      selectedService?.service_hours &&
        estimatedRequestData?.path &&
        estimatedData &&
        !selectedService?.suggest_earliest_block_hour
    );
  }, [
    selectedService?.service_hours,
    selectedService?.suggest_earliest_block_hour,
    estimatedRequestData?.path,
    estimatedData,
  ]);

  if (showSamedayHour) {
    return <BookingSamedayHour onSchedule={onSchedule} />;
  } else if (bestHourSuggest?.length) {
    return <BookingBestHourSuggest onSchedule={onSchedule} />;
  }

  return (
    <BookingDateTimePicker
      onSchedule={onSchedule}
      initialTime={orderTime}
      maxDayDuration={selectedService?.max_idle_until}
    />
  );
};

export default DateTimePickerByService;
